import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { Breadcrumb } from '../../models/breadcrumb.model';
import { Router, RouterLink } from '@angular/router';
import { Location } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IconComponent, RouterLink],
})
export class BreadcrumbsComponent {
  private router = inject(Router);

  @Input() breadcrumbs: Breadcrumb[] = [];
  @Input() showHome: boolean = true;

  location = inject(Location);

  get crumbs() {
    if (this.showHome) {
      return [
        {
          label: 'Home',
          routerLink: ['/'],
        },
        ...this.breadcrumbs,
      ];
    }
    return this.breadcrumbs;
  }
  get backCrumb() {
    if (this.crumbs.length > 1) {
      return this.crumbs[this.crumbs.length - 2];
    }
    return {
      label: 'Home',
      routerLink: ['/'],
    };
  }

  goBack(): void {
    const navigationId = (this.location.getState() as any)?.navigationId || 0;
    if (navigationId > 1) {
      this.location.back();
    } else {
      this.router.navigate(this.backCrumb.routerLink, { queryParams: this.backCrumb.params });
    }
  }
}
